import http from "./httpService";

class CommonApi {
  headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  };

  async loadPortal(data) {
    const query = window.location.search;
    var path = window.location.pathname;
    path = path.length === 0 ? '/' : path;
    const custHeader ={
		...this.headers,
      "portalpath": path,
    };

    return http.post(`${process.env.REACT_APP_BASE_URL ?? ''}api/portal/load${query}`, JSON.stringify(data), {
		headers: custHeader
	});
  }

  async getPortalInfo() {
    const query = window.location.search;
    var path = window.location.pathname;
    path = path.length === 0 ? '/' : path;
    const custHeader ={
    	...this.headers,
      "portalpath": path,
    };

    return http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/portal/info${query}`, {
		headers: custHeader
	});
  }

  async getPartnerInfo() {
    const response = await http.get(process.env.REACT_APP_BASE_URL + `api/partner`);
    return response;
  }

  async getPartnerStore() {
    return http.get(process.env.REACT_APP_BASE_URL + `api/partner/store`);
  }

  async getPartnerTrackingCode() {
    return http.get(process.env.REACT_APP_BASE_URL + `api/partner/tracking/code`);
  }

  async testExistEmail(email) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/email/exist/${email}`);
  }

  async testExistPhoneNumber(phone) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/phone/exist/${phone}`);
  }

  async updateCustomer(data) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/customer`, JSON.stringify(data), {
      headers: this.headers,
    });
  }

  async lookupCustomer(birthday, firstName, lastName, email, phone) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/lookup?birthday=${birthday}&firstName=${firstName}&lastName=${lastName}&email=${email}&phone=${phone}`);
  }

  async getCustomerInfo(customerId) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/customer/${customerId}`);
  }

  async getBookingInfo(bookingId) {
    return http.get(process.env.REACT_APP_BASE_URL + `api/booking/${bookingId}`);
  }

  async updateBooking(data) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/booking`, JSON.stringify(data), {
      headers: this.headers,
    });
  }

  async setBillMethodDefault(data) {
    return http.post(process.env.REACT_APP_BASE_URL + `api/bill/method`, JSON.stringify(data), {
      headers: this.headers,
    });
  }

  async getLocationList(status = "ACTIVE", returnMaster = true, sortOrder = {}) {
    const sortField = sortOrder.sort?.toUpperCase() || '';
    const orderType = sortOrder.order || '';
    return http.get(process.env.REACT_APP_BASE_URL + `api/location/list?status=${status}&sort=${sortField}&sortOrder=${orderType}&returnMaster=${returnMaster}&internal=false`);
  }

  async getLocationHours(id, pickupType) {
    return await http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/location/${id}/hour?pickupType=${pickupType}`);
  }
  async getCombLocationHours(pickupType) {
    return await http.get(`${process.env.REACT_APP_BASE_URL ?? ''}api/location/hour?pickupType=${pickupType}`);
  }
}

export const commonApi = new CommonApi();
